import * as urlWebservice from "utils/apis"
import * as actionsWebservice from "utils/functions/httpMethods"

export const loginService = async (payload) => {
  try {
    const results = await actionsWebservice.postAUth(urlWebservice.LOGIN, payload)
    return results
  } catch (error) {
    return error
  }
}
export const forgetPasswordService = async (payload) => {
  try {
    const results = await actionsWebservice.postAUth(urlWebservice.FORGET_PASSWORD, payload)
    return results
  } catch (error) {
    return error
  }
}
export const checkPasswordTokenService = async (payload) => {
  try {
    const results = await actionsWebservice.postAUth(urlWebservice.CHECK_PASSWORD_TOKEN, payload)
    return results
  } catch (error) {
    return error
  }
}
export const resetPasswordService = async (payload) => {
  try {
    const results = await actionsWebservice.postAUth(urlWebservice.RESET_PASSWORD, payload)
    return results
  } catch (error) {
    return error
  }
}
export const getMe = async (payload) => {
  try {
    const results = await actionsWebservice.postAUth(urlWebservice.GET_ME, payload)
    return results
  } catch (error) {
    return error
  }
}
